/// <amd-module name="TFS/Admin/Common/Util/PermissionsHelper" />
import { PermissionValue, SubjectPermission } from "TFS/Admin/Common/Contracts/OrganizationSettings";
import * as Resources from "TFS/Admin/Common/Resources";

/// <amd-module name="TFS/Admin/Common/Util/PermissionsHelper" />
export function getPermissionDisplayString(permissionValue: number): string {
    switch (permissionValue) {
        case PermissionValue.NotSet:
            return Resources.PV_NotSet;

        case PermissionValue.Allow:
            return Resources.PV_Allow;

        case PermissionValue.Deny:
            return Resources.PV_Deny;

        case PermissionValue.InheritedAllow:
            return Resources.PV_InheritedAllow;

        case PermissionValue.InheritedDeny:
            return Resources.PV_InheritedDeny;

        case PermissionValue.AllowedBySystem:
            return Resources.PV_AllowedBySystem;

        case PermissionValue.DeniedBySystem:
            return Resources.PV_DeniedBySystem;
        default:
            return Resources.PV_NotSet;
    }
}

export const PermissionsValueDisplayNames: string[] = [Resources.PV_NotSet, Resources.PV_Allow, Resources.PV_Deny];

export function generateRowId(permission: SubjectPermission): string {
    return permission.namespaceId + permission.bit;
}

export function generateRowIdDirect(namespaceId: string, bit: number): string {
    return namespaceId + bit;
}

export function getPermissionId(displayName: string): PermissionValue {
    switch (displayName) {
        case Resources.PV_NotSet:
            return PermissionValue.NotSet;
        case Resources.PV_Allow:
            return PermissionValue.Allow;
        case Resources.PV_Deny:
            return PermissionValue.Deny;
        case Resources.PV_InheritedAllow:
            return PermissionValue.InheritedAllow;
        case Resources.PV_InheritedDeny:
            return PermissionValue.InheritedDeny;
        case Resources.PV_AllowedBySystem:
            return PermissionValue.AllowedBySystem;
        case Resources.PV_DeniedBySystem:
            return PermissionValue.DeniedBySystem;
        default:
            return PermissionValue.NotSet;
    }
}
